'use client'

import { Icon } from '@/components/Icon'
import styles from '@/components/Sidebar/Trigger/SidebarTrigger.module.scss'
import React, { Ref } from 'react'
import { clsx } from 'clsx'
import { useSidebar } from '@/context/SidebarContext'

const SidebarTrigger = ({
  id,
  sidebarId,
  className,
  theme,
  size = 24,
}: {
  id?: string
  sidebarId: string
  className?: string
  theme?: 'light' | 'dark'
  size?: number
}) => {
  const { open } = useSidebar()

  return (
    <button
      id={id}
      className={className}
      aria-label="Seitennavigation öffnen"
      onClick={() => open(sidebarId, sidebarId)}
    >
      <Icon name="hamburger" className={clsx(styles.icon, theme)} size={size} />
    </button>
  )
}

export default SidebarTrigger
